import { Injectable }               from '@angular/core';
import { Http }                     from '@angular/http';
import { ISortableFilter }          from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { CommonService }            from './common.service';
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class MonitoringService {

    private _commonService: CommonService;

    constructor(public authHttp: AuthHttp, private http: Http, private globals: Globals, public snackbar: MatSnackBar) {
        this._commonService = new CommonService(authHttp, http, globals, 'ActiveConnection', snackbar);
    }

    public getPosLog(filter: ISortableFilter): Observable<any> {
        return this._commonService.get('PosLog', filter);
    }

    public getDataLog(filter: ISortableFilter): Observable<any> {
        return this._commonService.get('DataLog', filter);
    }

    public getReceiptList(filter: ISortableFilter): Observable<any> {
        return this._commonService.get('ReceiptList', filter);
    }

    public getReceiptDetail(recUid: string, slotId: string): Observable<any> {
        return this._commonService.get('ReceiptDetail?recUid=' + recUid + '&slotId=' + slotId);
    }

    public getDataLogFilePath(id: string) {
        let filePath = this.globals.GetUrlPrefix() + '/api/ActiveConnection/DataLogFile/' + id;
        return filePath;
    }

    public pdf(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.pdf(filter, columnParams, pageOrientation);
    }

    public csv(filter: ISortableFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.csv(filter, columnParams, pageOrientation);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/monitoring.service.ts